import styled from 'styled-components';

const StoriesStyles = styled.div`
  padding: 3rem 0 1rem 0;

  .success-stories {
    margin: 0;
    padding: 0;
    list-style: none;

    .success-story {
      margin: 0 0 2rem;
      padding: 1.5rem;
      border: 0.0625rem solid var(--color-swiss-coffee);

      .image-wrapper {
        display: block;
        margin: 0 0 1.5rem;

        .image {
          width: 100%;
          aspect-ratio: 16 / 9;
        }
      }

      .matched-by {
        display: flex;
        align-items: center;
        gap: 0.75rem;
        margin: 0.5rem 0 1.3rem;
        color: var(--color-charcoal);

        .headshot {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 3.5rem;
          height: 3.5rem;
          border-radius: 100%;
          background-color: var(--color-sand);
        }

        .name {
          margin: 0 0 0.4rem;
          font-size: 1rem;
          line-height: 1;
          text-transform: none;
        }

        .job-title {
          line-height: 1;
          opacity: 0.6;
        }
      }

      .read-more {
        display: inline-block;
        margin: 1rem 0 0;
      }

      &:last-child {
        margin: 0;
      }
    }
  }

  .controls {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin: 3rem 0 2rem;
  }

  @media (min-width: 768px) {
    .success-stories {
      display: flex;
      flex-wrap: wrap;
      gap: 2rem;

      .success-story {
        margin: 0;
        width: calc(50% - 1rem);

        .matched-by .headshot {
          width: 4.5rem;
          height: 4.5rem;
        }
      }
    }

    .controls {
      margin: 3rem 0 4rem;
    }
  }

  @media (min-width: 992px) {
    .success-stories {
      .success-story {
        width: calc(33.333% - 2rem);

        .matched-by .name {
          font-size: 1.125rem;
        }
      }
    }
  }
`;

export default StoriesStyles;
